// extracted by mini-css-extract-plugin
export var box = "_43-1";
export var checkboxRow = "_43-8";
export var checked = "_43-2";
export var descriptionSpacer = "_43-a";
export var disabled = "_43-3";
export var icon = "_43-6";
export var input = "_43-0";
export var labelSpacer = "_43-9";
export var medium = "_43-5";
export var small = "_43-4";
export var text = "_43-7";